<template>
	<div ref="content" class="content background2">
		<div ref="search" style="width: 100%; height: 60px; background-color: #FFFFFF;">
			<SearchList class="newSearchList" ref="searchContent" :searchList="searchList" ></SearchList>
			<!-- <span class="search-label">客户名称</span>
			<el-autocomplete  :readonly="false" v-model="companyName" :fetch-suggestions="queryCompany"
			 @select="selectCompany" :trigger-on-focus="true" class="autoinput"></el-autocomplete> -->
		</div>
		<div ref="btnList">
			<BtnList ref="btn" :btnList="btnList"></BtnList>
		</div>
		<div ref="tableList" class="list" :style="{'padding-top':paddingTop}">

			<List ref="list" :tableData="tableData" :tableList="tableList" :pageSize="pageSize" :pageNo="pageNo"
				@parentMethod="getInfo"></List>
		</div>
		<div ref="page" class="page">
			<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
				@parentMethod="search"></Page>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css"
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import User from "@/assets/js/system/user.js";
	import Common from "@/assets/js/common/common.js";
	export default {
		name: 'list',
		components: {
			List,
			SearchList,
			BtnList,
			Page
		},
		data() {
			const $this = this;
			return {
				paddingTop: 0,
				companyName:'11',
				searchList: [{
						searchLabel: '设备编号',
						searchValue: '',
						searchType: 0,
						searchWidth: '25%',
						searchBr: false,
						column: 'code',
					},
					{
						searchLabel: '设备类型',
						searchValue: '',
						searchType: 1,
						searchTermList: [],
						searchWidth: '25%',
						searchBr: false,
						column: 'deviceType',
					},
					{
						searchLabel: '设备名称',
						searchValue: '',
						searchType: 0,
						searchWidth: '25%',
						searchBr: false,
						column: 'name',
					},
					{
						searchLabel: '客户名称',
						searchValue: '',
						searchType: 5,
						searchTermList: [1,2,3],
						searchWidth: '25%',
						searchBr: false,
						column: 'customerName',
					},
				],
				btnList: [],
				tableList: [{
					column: 'customerName',
					title: '客户名称',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'code',
					title: '设备编号',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'name',
					title: '设备名称',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'deviceModel',
					title: '设备型号',
					headerAlign: 'center',
					align: 'center',
					termList: [],
					width: '20%'
				}, {
					column: 'deviceType',
					title: '设备类型',
					headerAlign: 'center',
					align: 'center',
					termList: [],
					width: '20%'
				}, {
					column: 'deviceAddress',
					title: '安装位置',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				} ,{
					column: 'bindtime',
					title: '安装日期',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'testDate',
					title: '第三方检测到期日',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'productionUnit',
					title: '生产单位',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'useDate',
					title: '设备使用到期年限',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'notes',
					title: '监控燃气种类',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				},{
          column: 'shescalationflag',
          title: '上海平台上报',
          headerAlign: 'center',
          align: 'center',
          width: '20%'
        },{
          column: 'pdescalationflag',
          title: '浦东平台上报',
          headerAlign: 'center',
          align: 'center',
          width: '20%'
        }],
				tableData: [],
				tableInfo: {},
				pageCount: 0,
				pageSize: 0,
				pageNo: 1,
			}
		},
		methods: {
			queryArea() {},
			getDeviceList(param) {
				User.getDeviceList(param).then((response) => {
					const data = response.data;
					this.pageCount = data.data.total;
					this.pageNo = data.data.current;
					this.$refs['pageModel'].setCurrent(this.pageNo);
					// console.log(data.data.records);
					this.tableData = data.data.records;
          for(var i=0;i<this.tableData.length;i++){
            if(this.tableData[i].pdescalationflag==0){
              this.tableData[i].pdescalationflag='否';
            }else{
              this.tableData[i].pdescalationflag='是';
            }
            if(this.tableData[i].shescalationflag==0){
              this.tableData[i].shescalationflag='否';
            }else{
              this.tableData[i].shescalationflag='是';
            }
          }
				}).catch((response) => {
					console.log(response)
				})
			},
			search(param) {
				var dataParam = this.$refs.searchContent.getSearchParam();
				// console.log(dataParam)
				var newParam = Object.assign(param, dataParam);
				this.getDeviceList(newParam);
			},
			getWindowHeight() {
				let height = '';
				height = this.$refs.tableList.clientHeight - (this.$refs.search.clientHeight + this.$refs.btnList
					.clientHeight +
					20) - 60;
				this.height = height;
				if (height > 550) {
					let line = parseInt((height - 10) / 50);
					if (this.pageSize != line) {
						this.pageSize = line;
					}
				} else {
					if (this.pageSize != 10) {
						this.pageSize = 10;
					}
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
			getInfo(info) {
				this.tableInfo = info;
			},

		},
		created() {
			this.menuList = this.$store.getters.getMenuPermission;
			const $this = this;
			if (this.menuList.indexOf("CD_661") != -1) {
				this.btnList.push({
					btnLabel: '新增',
					btnType: 1,
					btnPosition: 'left',
					title: '新增',
					columnList: [{
							columnLabel: '设备编号',
							value: '',
							column: 'code',
							columnType: 0,
							placeholder: '请输入设备编号',
						},
						{
							columnLabel: '设备名称',
							value: '',
							column: 'name',
							columnType: 0,
							placeholder: '请输入设备名称',
						}, {
							columnLabel: '设备型号',
							value: '',
							column: 'deviceModel',
							columnType: 1,
							placeholder: '请输入设备型号',
							columnTermList: []
						}, {
							columnLabel: '设备类型',
							value: '',
							column: 'deviceType',
							columnType: 1,
							placeholder: '请输入设备类型',
							columnTermList: []
						}, {
							columnLabel: '保修时长（天）',
							value: '',
							column: 'warranty',
							columnType: 0,
							placeholder: '请输入保修时长（天）',
						}, {
							columnLabel: '生产单位',
							value: '',
							column: 'productionUnit',
							columnType: 0,
							placeholder: '请输入生产单位',
						}, {
							columnLabel: '生产日期',
							value: '',
							column: 'productionDate',
							columnType: 5,
							placeholder: '请输入生产日期',
						}, {
							columnLabel: '第三方检测到期日',
							value: '',
							column: 'testDate',
							columnType: 5,
							placeholder: '请输入第三方检测到期日',
						}, {
							columnLabel: '设备使用到期年限',
							value: '',
							column: 'useDate',
							columnType: 11,
							placeholder: '请输入设备使用到期年限',
						},
						{
							columnLabel: '监控燃气种类',
							value: '',
							column: 'notes',
							columnType: 10,
							placeholder: '请选择监控燃气种类',
							columnTermList: []
						},{
							columnLabel: '上海平台上报',
							value: false,
							column: 'shescalationflag',
							columnType: 12,
							placeholder: '请选择',
							columnTermList:[],
              toptitle:'是',
              downtitle:'否'
						},{
							columnLabel: '上海平台上报工单号',
							value: '',
							column: 'shworkordernum',
							columnType: 0,
							placeholder: '请输入工单号',
						},{
							columnLabel: '浦东平台上报',
							value: false,
							column: 'pdescalationflag',
							columnType: 12,
							placeholder: '请选择',
							columnTermList: [],
              toptitle:'是',
              downtitle:'否'
						},
					],
					btnClick: function(tip) {
						tip();
						$this.btnList[0].columnList.forEach(function(item, index) {
							if (index == 7) {
								var myDate = new Date();
								var year = myDate.getFullYear() + 1; // 获取一年后
								var month = myDate.getMonth() + 1; // 获取当前月份
								if (month < 10) {
									month = '0' + month;
								}
								var day = myDate.getDate(); // 获取当前日
								if (day < 10) {
									day = '0' + day;
								}
								item.value = year + '-' + month + '-' + day;
							} else if (index == 8) {
								var myDate = new Date();
								var year = myDate.getFullYear() + 1; // 获取一年后
								var month = myDate.getMonth() + 1; // 获取当前月份
								if (month < 10) {
									month = '0' + month;
								}
								item.value = year + '-' + month;
							}else if(index==10){
                item.value =false;
              }else if(index==12){
                item.value =false;
              }else {
								item.value = '';
							}
						})
					},
					btnFun: function(tip, info) {
						info.price = Number(info.price)
						info.warranty = Number(info.warranty)
						if (info.code == "") {
							$this.utils.tipsAlert('请填写设备编号');
							return
						}
						if (info.name == "") {
							$this.utils.tipsAlert('请填写设备名称');
							return
						}
						if (info.deviceType == "") {
							$this.utils.tipsAlert('请选择设备类型');
							return
						}
						if (info.warranty == "") {
							$this.utils.tipsAlert('请填写保修时长');
							return
						}
						if (info.productionDate == "") {
							$this.utils.tipsAlert('请填写生产日期');
							return
						}
						if (info.testDate == "" || info.testDate == null) {
							$this.utils.tipsAlert('请填写第三方检测到期日');
							return
						}
						if (info.useDate == "") {
							$this.utils.tipsAlert('请填写设备使用到期年限');
							return
						}
						if (info.notes == "") {
							$this.utils.tipsAlert('请选择监控燃气种类');
							return
						}
						let note = "";
						for (var item in info.notes) {
							note += info.notes[item] + "/";
						}
						info.notes = note.substr(0, note.length - 1);
            if(info.pdescalationflag==false){
              info.pdescalationflag=0;
            }else{
              info.pdescalationflag=1;
            }
            if(info.shescalationflag==false){
              info.shescalationflag=0;
            }else{
              info.shescalationflag=1;
            }
						User.addEquipment(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.saveAlert();
								$this.search({
									pageNo: 1,
									pageSize: $this.pageSize
								});
								$this.btnList[0].columnList.forEach(function(item, index) {
									item.value = '';
								})
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {
							console.log(response)
						})
            info.pdescalationflag=false;
            info.shescalationflag=false;
					}
				});
			}
			if (this.menuList.indexOf("CD_662") != -1) {
				this.btnList.push({
					btnLabel: '编辑',
					btnType: 4,
					btnPosition: 'left',
					title: '编辑',
					columnList: [{
							columnD: true,
							columnLabel: '设备编号',
							value: '',
							column: 'code',
							columnType: 0,
							placeholder: '请输入设备编号',
						},
						{
							columnLabel: '设备名称',
							value: '',
							column: 'name',
							columnType: 0,
							placeholder: '请输入设备名称',
						}, {
							columnLabel: '设备型号',
							value: '',
							column: 'deviceModel',
							columnType: 1,
							placeholder: '请输入设备型号',
							columnTermList: []
						}, {
							columnLabel: '设备类型',
							value: '',
							column: 'deviceType',
							columnType: 1,
							columnTermList: [],
							placeholder: '请输入设备类型',
						}, {
							columnLabel: '保修时长（天）',
							value: '',
							column: 'warranty',
							columnType: 0,
							placeholder: '请输入保修时长（天）',
						}, {
							columnLabel: '生产单位',
							value: '',
							column: 'productionUnit',
							columnType: 0,
							placeholder: '请输入生产单位',
						}, {
							columnLabel: '生产日期',
							value: '',
							column: 'productionDate',
							columnType: 5,
							placeholder: '请输入生产日期',
						}, {
							columnLabel: '第三方检测到期日',
							value: '',
							column: 'testDate',
							columnType: 5,
							placeholder: '请输入第三方检测到期日',
						}, {
							columnLabel: '设备使用到期年限',
							value: '',
							column: 'useDate',
							columnType: 11,
							placeholder: '请输入设备使用到期年限',
						},
						{
							columnLabel: '监控燃气种类',
							value: '',
							column: 'notes',
							columnType: 10,
							placeholder: '请选择监控燃气种类',
							columnTermList: []
						},{
							columnLabel: '上海平台上报',
							value: '',
							column: 'shescalationflag',
							columnType: 12,
							placeholder: '请选择',
							columnTermList: [],
              toptitle:'是',
              downtitle:'否'
						},{
							columnLabel: '上海平台上报工单号',
							value: '',
							column: 'shworkordernum',
							columnType: 0,
							placeholder: '请输入工单号',
						},{
							columnLabel: '浦东平台上报',
							value: '',
							column: 'pdescalationflag',
							columnType: 12,
							placeholder: '请选择',
							columnTermList: [],
              toptitle:'是',
              downtitle:'否'
						},
					],
					btnClick: function(tip) {
						if (Object.keys($this.tableInfo).length > 0) {
							tip();
							$this.btnList[1].columnList.forEach(function(item, index) {
								if (index == 9) {
									item.value = $this.tableInfo[item.column].split('/');
								}else if(index == 10||index == 12){
                  if($this.tableInfo[item.column]=="是"){
                    item.value=true;
                  }else{
                    item.value=false;
                  }
                } else {
									item.value = $this.tableInfo[item.column];
								}
							})
						} else {
							$this.utils.tipsAlert('请选择数据');
						}
					},
					btnFun: function(tip, info) {
						info.customerId = $this.tableInfo.customerId
						info.id = $this.tableInfo.id
						if (info.code == "") {
							$this.utils.tipsAlert('请填写设备编号');
							return
						}
						if (info.name == "") {
							$this.utils.tipsAlert('请填写设备名称');
							return
						}
						if (info.deviceType == "") {
							$this.utils.tipsAlert('请选择设备类型');
							return
						}
						if (info.warranty == "") {
							$this.utils.tipsAlert('请填写保修时长');
							return
						}
						if (info.productionDate == "") {
							$this.utils.tipsAlert('请填写生产日期');
							return
						}
						if (info.testDate == "" || info.testDate == null) {
							$this.utils.tipsAlert('请填写第三方检测到期日');
							return
						}
						if (info.useDate == "" || info.useDate == null) {
							$this.utils.tipsAlert('请填写设备使用到期年限');
							return
						}
						info.code = info.code.trim();

						if (info.notes == "") {
							$this.utils.tipsAlert('请选择监控燃气种类');
							return
						}
						let note = "";
						for (var item in info.notes) {
							note += info.notes[item] + "/";
						}
						info.notes = note.substr(0, note.length - 1);
            if(info.pdescalationflag==false){
              info.pdescalationflag=0;
            }else{
              info.pdescalationflag=1;
            }
            if(info.shescalationflag==false){
              info.shescalationflag=0;
            }else{
              info.shescalationflag=1;
            }
						User.updataEquipment(info).then((response) => {
							const data = response.data;
							if (data.code == 1) {
								$this.utils.editAlert();
								$this.search({
									pageNo: 1,
									pageSize: $this.pageSize
								});
								tip()
							} else {
								$this.utils.tipsAlert(data.message);
							}
						}).catch((response) => {
							console.log(response)
						})
					}
				});
			}
			if (this.menuList.indexOf("CD_663") != -1) {
				this.btnList.push({
					btnLabel: '删除',
					btnType: 0,
					btnPosition: 'left',
					btnFun: function() {
						if (Object.keys($this.tableInfo).length > 0) {
							$this.$confirm('是否删除这个设备?', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								let ids = [$this.tableInfo.id]
								User.delEquipment(ids).then((response) => {
									const data = response.data;
									if (data.code == 1) {
										$this.utils.delAlert();
									} else {
										$this.utils.tipsAlert(data.message);
									}
									$this.search({
										pageNo: 1,
										pageSize: $this.pageSize
									});
								}).catch((response) => {
									console.log(response)
								})
							});
						}
					}
				});
			}
			this.btnList.push({
				btnLabel: '查询',
				btnType: 3,
				btnPosition: 'right',
				btnFun: function() {
					$this.search({
						pageNo: 1,
						pageSize: $this.pageSize
					});
				},
			});
		},
		mounted() {
			this.paddingTop = (this.$refs.search.clientHeight + this.$refs.btnList.clientHeight + 20) + 'px';
			this.getWindowHeight();
			window.onresize = () => {
				this.$refs.list.getHeight();
				this.getWindowHeight();
			}
			let list = [];
			User.getDeviceType().then((response) => {
				const data = response.data.data;
				for (var i = 0; i < data.length; i++) {
					list.push({
						id: data[i].dataTypeCode,
						name: data[i].typeName,
					})
				}
				this.searchList[1].searchTermList = list;
				this.btnList[0].columnList[3].columnTermList = list;
				this.btnList[1].columnList[3].columnTermList = list;
				this.tableList[4].termList = list;
				this.userTypeList = list;
			}).catch((response) => {
				console.log(response)
			})
			let list1 = [];
			Common.getDict('燃气类型').then((response) => {
				const data = response.data.data;
				for (var i = 0; i < data.length; i++) {
					list1.push({
						id: data[i].id,
						name: data[i].value,
					})
				}
				this.btnList[0].columnList[9].columnTermList = list1;
				this.btnList[1].columnList[9].columnTermList = list1;
			}).catch((response) => {
				console.log(response)
			})
			let list2 = [];
			Common.getDict('设备型号').then((response) => {
				const data = response.data.data;
				for (var i = 0; i < data.length; i++) {
					list2.push({
						id: data[i].id,
						name: data[i].value,
					})
				}
				this.btnList[0].columnList[2].columnTermList = list2;
				this.btnList[1].columnList[2].columnTermList = list2;
				this.tableList[3].termList = list2;
			}).catch((response) => {
				console.log(response)
			})
		}
	}
</script>
<style >
	.newSearchList{
		width: 100%;
		float: left;
	}
	.spanlable{
	    padding: 0 5px;
	    padding-top: 15px;
	    width: 100px;
	    font-size: 14px;
	    height: 100%;
	}
	.autoinput{
		width: calc(25% - 100px);
	}
</style>



// WEBPACK FOOTER //
// src/pages/system/equipment.vue